import { lastSeen } from '~/helpers/fields-description';
import { NAModule } from '~/models/modules/NAModule.model';

export class ELK extends NAModule {
    hasOperationDissociate = false;
    hasOperationReset = false;
    hasOperationImportData = false;

    isWired = true;

    get fieldName() {
        return undefined;
    }
    get fieldRoom() {
        return undefined;
    }
    get fieldSetupDate() {
        return undefined;
    }
    get fieldLastSetup() {
        return undefined;
    }
    get lastSeenField() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }

}
